import { render, staticRenderFns } from "./SelectSemenForm.vue?vue&type=template&id=29fb398f&scoped=true&"
import script from "./SelectSemenForm.vue?vue&type=script&lang=ts&"
export * from "./SelectSemenForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fb398f",
  null
  
)

export default component.exports